import * as React from 'react'
function SvgDashboard(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M16 26a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2h10zm18-6a2 2 0 012 2v12a2 2 0 01-2 2H24a2 2 0 01-2-2V22a2 2 0 012-2h10zM16 4a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h10zm18 0a2 2 0 012 2v8a2 2 0 01-2 2H24a2 2 0 01-2-2V6a2 2 0 012-2h10z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDashboard
